<div class="width-100 container-modal-header">
  <div class="width-100">
    <h4 class="text-left">Arredondamento de dose por tanque</h4>
  </div>
  <div>
    <button type="button" class="btn btn-link" ng-click="$ctrl.closeModal()"
      uib-tooltip="Fechar" tooltip-append-to-body="true" tooltip-placement="bottom-right">
      <i class="fa fa-close button-grey-color"></i>
      </button>
  </div>
</div>

<div class="container-modal-body">
  <p>Para fazer o arredondamento por tanque, primeiro informe a capacidade.</p>
  
  <div class="width-100 padding-top-10">
    <div class="form-group inline-flex width-100 justify-between">
      <input ng-model="$ctrl.capacidadeTanque"
        ng-keypress="$event.which === 13 && $ctrl.capacidadeTanque"
        ng-blur="$ctrl.formatCapacidadeTanqueDisplay()"
        class="form-control width-80"
        placeholder="Capacidade do tanque"
        type="text"
        inputmode="decimal"
        ng-pattern="/^\d+([.,]\d+)*$/"
        id="capacidadeTanque"
        name="capacidadeTanque"
        autofocus
      >
      <button ng-click="$ctrl.applyCapacidadeTanque(true)"
            ng-disabled="!$ctrl.isCapacidadeTanqueValida()"
            class="btn btn-action width-20 apply-button"
            type="button"
            title="Aplicar">
        Aplicar
      </button>
    </div>
  </div>

  <div class="width-100 padding-top-9 info-box" ng-show="$ctrl.showDoseTable">
    <div class="width-80" ng-style="{padding: 8}">

      <div class="inline-flex width-100 justify-between">
        <div class="width-100">
          <p class="font-small-size"><strong>Área Total: </strong> {{$ctrl.recomendacao.glebas.areaTotal | number: 2}} ha</p>
        </div>
        <div class="width-100 margin-left-20">
          <p class="font-small-size"><strong>Nº Abastecidas: </strong> {{$ctrl.abastecidas | number: 2}}</p>
        </div>
      </div>
      <div class="inline-flex width-100 justify-between">
        <div class="width-100">
          <p class="font-small-size"><strong>Capacidade do Tanque: </strong> {{$ctrl.capacidadeTanque}} l</p>
        </div>
        <div class="width-100 margin-left-20">
          <p class="font-small-size"><strong>Vazão: </strong> {{$ctrl.recomendacao.vazao}} l/ha</p>
        </div>
      </div>
    </div>
  </div>

  <div class="width-100 margin-top-12" ng-show="$ctrl.showDoseTable">
    <div class="form-group">
      <table class="table">
        <thead>
          <tr>
            <th style="width: 25%;">Produto</th>
            <th style="width: 15%;">Dose</th>
            <th style="width: 30%;">Dose por tanque (L)</th>
            <th style="width: 30%;">Quantidade Total</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="produto in $ctrl.produtos track by produto.id">
            <td class="vertical-align-middle">{{produto.descricao}}</td>
            <td class="vertical-align-middle" ng-class="{'text-danger': !$ctrl.isProdutoResultadoValido(produto)}">{{produto.dose | formatDynamicDecimals:false}}</td>
            <td class="vertical-align-middle">
              <div>
                <input ng-model="produto.doseByTanque"
                  class="form-control"
                  ng-class="{'input-error': !$ctrl.isProdutoValido(produto)}"
                  ng-change="$ctrl.recalculateValues(produto)"
                  ng-blur="$ctrl.formatDoseByTanqueDisplay(produto)"
                  placeholder="Dose por tanque"
                  type="text"
                  inputmode="decimal"
                >
                <small class="help-block-message text-danger" ng-if="!$ctrl.isProdutoValido(produto)">
                  {{$ctrl.getMensagemErro(produto)}}
                </small>
              </div>
            </td>
            <td class="vertical-align-middle" ng-class="{'text-danger': !$ctrl.isProdutoResultadoValido(produto)}">{{produto.qtTotal | formatDynamicDecimals:false}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal-footer width-100 container-modal-footer">
  <div class="row pull-right">
    <div class="col-xs-12 btn-group pull-right">
      <button class="btn btn-default btn-sm btn-action" type="button" ng-click="$ctrl.closeModal()">Cancelar</button>
      <button class="btn btn-primary btn-sm btn-action margin-left-10" type="submit"
              ng-click="$ctrl.save()"
              ng-disabled="!$ctrl.isCapacidadeTanqueValida() || !$ctrl.produtos.length || !$ctrl.validaProdutos()">
        Salvar
      </button>
    </div>
  </div>
</div>
